const isWebLink = /^https?:\/\/.+/i;
export const isExternalLink = (link) => Boolean(link && isWebLink.test(link));
